import styled from 'styled-components';

interface RowProps {
  isDragOver?: boolean;
}

export const Row = styled.tr<RowProps>`
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  background-color: ${(props) => props.theme.colors.table.row};

  &:last-child > td {
    border-bottom: none;
  }

  & td {
    border-top: ${(props) =>
      props.isDragOver ? `1px solid ${props.theme.colors.primary}` : ''};
  }

  &:hover td {
    transition: all 0.2s ease-in-out;
    background-color: ${(props) => props.theme.colors.table.rowHover};
  }
`;
